import { Button, Grid } from '@hiiretail/react-foundation-ui';
import { useIntl } from 'react-intl';

const styles = {
  textTransform: 'uppercase',
  boxShadow: 'none',
  fontSize: 20,
};

export const SubmitReceiptButton = ({ loading }: { loading: boolean }) => {
  const intl = useIntl();

  return (
    <Grid item xs={12} sm="auto">
      <Button type="submit" variant="contained" sx={styles} disabled={loading}>
        {loading
          ? intl.formatMessage({ id: 'receipt.button.submitting' })
          : intl.formatMessage({ id: 'receipt.button.submit' })}
      </Button>
    </Grid>
  );
};
